import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import { Button, SectionTitle } from '../shared'

const Section = styled.section<{ isDesktop: boolean }>`
  background-color: #002244;
  height: ${(props) => (props.isDesktop ? '355px' : 'auto')};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    margin-bottom: 2rem;
  }
`

const CTA: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['md', 'lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <SectionTitle>
        Ready to amplify your voice? <br />
        Join the Podcast Incubator Community.
      </SectionTitle>
      <Button
        external
        variant="red"
        path="https://sbupodcastincubator.substack.com/"
        size="lg"
      >
        Join our Substack
      </Button>
    </Section>
  )
}

export default CTA
